import spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class BigWinTitle extends spine{
  constructor(data) {
    super(create(data, { spine: 'animations/spine/win/skeleton.json' }))
    this._data = data
    this._scale = data.scale || 0.5
    game.bigwin.title = this

    this.state.addListener({
      event: function (entry, event) {
        signal.dispatch(event.data.name)
      },
    })

    this.resize(this)
  }
  resize(object) {
    const self = this
    signal.on('RESIZE', function ({ stage }) {
      object.scale.set(self._scale)
      object.x = ((stage.width - object.width) / 2) + object.width / 2
      object.y = ((stage.height - object.height) / 2) + object.height / 2

    })
  }

}
